// Mycavvie theme JS — cart drawer, header search, quick add, quantity, mobile nav, signup popup
(function(){
  'use strict';

  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  const money = (cents) => {
    if (window.Shopify && window.Shopify.currency) {
      return (cents/100).toLocaleString(undefined, {style:'currency', currency: window.Shopify.currency.active || 'USD'});
    }
    return '$' + (cents/100).toFixed(2);
  };

  // ---------- Cart Drawer ----------
  const CartDrawer = {
    root: null,
    overlay: null,
    threshold: 12000,
    countryLabel: 'AU',

    init(){
      this.root = $('#CartDrawer');
      this.overlay = $('#CartOverlay');
      if(!this.root) return;
      this.threshold = parseInt(this.root.dataset.threshold || '12000', 10);
      this.countryLabel = this.root.dataset.country || 'AU';

      $$('[data-cart-open]').forEach(b => b.addEventListener('click', (e)=>{ e.preventDefault(); this.open(); }));
      $$('[data-cart-close]').forEach(b => b.addEventListener('click', () => this.close()));
      if(this.overlay) this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') this.close(); });

      $$('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', (e) => this.handleAdd(e, form));
      });

      document.addEventListener('click', (e) => {
        const qa = e.target.closest('[data-quick-add]');
        if(qa){
          e.preventDefault();
          const variantId = qa.dataset.variantId;
          if(variantId) this.addVariant(variantId, 1, qa);
        }
      });

      this.bindItemEvents();
    },

    open(){
      this.root.classList.add('is-open');
      if(this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close(){
      this.root.classList.remove('is-open');
      if(this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    async handleAdd(e, form){
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if(btn){ btn.disabled = true; btn.dataset._t = btn.textContent; btn.textContent = 'Adding…'; }
      const fd = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method:'POST', body: fd, headers:{ 'X-Requested-With':'XMLHttpRequest', 'Accept':'application/json' }});
        if(!res.ok) throw new Error('add failed');
        await this.refresh();
        this.open();
      } catch(err) {
        console.error(err); alert('Sorry, we could not add that. Please try again.');
      } finally {
        if(btn){ btn.disabled=false; btn.textContent = btn.dataset._t || 'Add to Cart'; }
      }
    },

    async addVariant(id, qty, btn){
      if(btn){ btn.disabled = true; btn.dataset._t = btn.textContent; btn.textContent = 'Adding…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body: JSON.stringify({ id, quantity: qty })
        });
        if(!res.ok) throw new Error('add failed');
        await this.refresh();
        this.open();
      } catch(err){ console.error(err); }
      finally { if(btn){ btn.disabled=false; btn.textContent = btn.dataset._t || 'Quick Add'; } }
    },

    async refresh(){
      const res = await fetch('/cart.js', { headers:{ 'Accept':'application/json' }});
      const cart = await res.json();
      this.render(cart);
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
    },

    bindItemEvents(){
      const itemsEl = $('#CartDrawerItems');
      if(!itemsEl) return;
      $$('[data-cart-inc]', itemsEl).forEach(b => b.addEventListener('click', () => this.updateQty(b.dataset.cartInc, +1)));
      $$('[data-cart-dec]', itemsEl).forEach(b => b.addEventListener('click', () => this.updateQty(b.dataset.cartDec, -1)));
      $$('[data-cart-remove]', itemsEl).forEach(b => b.addEventListener('click', () => this.remove(b.dataset.cartRemove)));
    },

    render(cart){
      const itemsEl = $('#CartDrawerItems');
      const subtotalEl = $('#CartDrawerSubtotal');
      const progressBar = $('#CartProgressBar');
      const progressText = $('#CartProgressText');
      const footer = $('#CartDrawerFooter');
      if(!itemsEl) return;

      if(cart.item_count === 0){
        itemsEl.innerHTML = `<div class="cart-empty">
          <h4>Your cart is empty</h4>
          <p>Add something lovely for your Cavalier.</p>
          <a href="/collections/all" class="btn btn-primary">Shop the store</a>
        </div>`;
        if(footer) footer.style.display = 'none';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-key="${item.key}">
            <img src="${item.image ? item.image.replace(/(\.[^./]+)$/, '_120x$1') : ''}" alt="${item.product_title}">
            <div>
              <p class="cart-item__title">${item.product_title}</p>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:.8rem;opacity:.65">${item.variant_title}</p>`:''}
              <p class="cart-item__price">${money(item.final_line_price)}</p>
              <div class="qty" role="group" aria-label="Quantity">
                <button data-cart-dec="${item.key}" aria-label="Decrease">−</button>
                <span>${item.quantity}</span>
                <button data-cart-inc="${item.key}" aria-label="Increase">+</button>
              </div>
            </div>
            <button class="cart-item__remove" data-cart-remove="${item.key}" aria-label="Remove ${item.product_title}" title="Remove">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>
            </button>
          </div>
        `).join('');
        if(footer) footer.style.display = '';
        if(subtotalEl) subtotalEl.textContent = money(cart.total_price);
        this.bindItemEvents();
      }

      if(progressBar && progressText){
        const total = cart.total_price;
        const pct = Math.min(100, Math.round((total / this.threshold) * 100));
        progressBar.style.width = pct + '%';
        if(total >= this.threshold){
          progressText.textContent = `You've unlocked free ${this.countryLabel} shipping! 🎉`;
        } else {
          const remaining = this.threshold - total;
          progressText.textContent = `You're ${money(remaining)} away from free ${this.countryLabel} shipping`;
        }
      }
    },

    async updateQty(key, delta){
      const line = $(`.cart-item[data-key="${key}"] .qty span`);
      const current = line ? parseInt(line.textContent, 10) : 1;
      const newQty = Math.max(0, current + delta);
      await this.change(key, newQty);
    },

    async remove(key){ await this.change(key, 0); },

    async change(id, quantity){
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json','Accept':'application/json' },
        body: JSON.stringify({ id, quantity })
      });
      await this.refresh();
    }
  };

  // ---------- Header Search (dropdown, native form submit + live results) ----------
  const HeaderSearch = {
    wrapper: null, toggle: null, input: null, results: null, timeout: null,
    init(){
      this.wrapper = $('[data-header-search]');
      if(!this.wrapper) return;
      this.toggle = $('[data-search-toggle]', this.wrapper);
      this.input = $('[data-header-search-input]', this.wrapper);
      this.results = $('[data-header-search-results]', this.wrapper);

      if(this.toggle){
        this.toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isOpen = this.wrapper.classList.toggle('is-open');
          this.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if(isOpen && this.input) setTimeout(() => this.input.focus(), 30);
        });
      }

      document.addEventListener('click', (e) => {
        if(this.wrapper.classList.contains('is-open') && !this.wrapper.contains(e.target)){
          this.wrapper.classList.remove('is-open');
          if(this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && this.wrapper.classList.contains('is-open')){
          this.wrapper.classList.remove('is-open');
          if(this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
        }
      });

      if(this.input){
        this.input.addEventListener('input', () => {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => this.query(this.input.value), 220);
        });
      }
    },
    async query(q){
      if(!this.results) return;
      if(!q || q.length < 2){ this.results.innerHTML = ''; return; }
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
        const res = await fetch(url);
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if(products.length === 0){ this.results.innerHTML = `<p style="padding:.5rem;opacity:.6;font-size:14px">No results for "${q}"</p>`; return; }
        this.results.innerHTML = products.map(p => `
          <a class="search-result" href="${p.url}">
            <img src="${p.image ? p.image : ''}" alt="${p.title}">
            <div style="flex:1"><strong>${p.title}</strong></div>
            <div class="search-result-price">${p.price || ''}</div>
          </a>
        `).join('');
      } catch(e){ console.error(e); }
    }
  };

  // ---------- Mobile menu ----------
  const MobileMenu = {
    init(){
      const btn = $('[data-mobile-menu-open]');
      const drawer = $('#MobileMenu');
      const overlay = $('#MobileMenuOverlay');
      const closeBtns = $$('[data-mobile-menu-close]');
      if(!btn || !drawer) return;
      const open = () => { drawer.classList.add('is-open'); if(overlay) overlay.classList.add('is-open'); document.body.style.overflow='hidden'; };
      const close = () => { drawer.classList.remove('is-open'); if(overlay) overlay.classList.remove('is-open'); document.body.style.overflow=''; };
      btn.addEventListener('click', open);
      closeBtns.forEach(b => b.addEventListener('click', close));
      if(overlay) overlay.addEventListener('click', close);
      document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') close(); });
    }
  };

  // ---------- Product gallery ----------
  const ProductGallery = {
    init(){
      const gallery = $('[data-product-gallery]');
      if(!gallery) return;
      const main = gallery.querySelector('[data-gallery-main]');
      $$('[data-gallery-thumb]', gallery).forEach(t => {
        t.addEventListener('click', () => {
          $$('[data-gallery-thumb]', gallery).forEach(x => x.classList.remove('is-active'));
          t.classList.add('is-active');
          const src = t.dataset.galleryThumb;
          if(main) main.querySelector('img').src = src;
        });
      });
    }
  };

  // ---------- Signup popup (homepage) ----------
  const SignupPopup = {
    STORAGE_KEY: 'mycavvie_signup_dismissed_until',
    TAB_HIDDEN_KEY: 'mycavvie_side_tab_hidden',
    popup: null, overlay: null,

    init(){
      this.popup = $('#SignupPopup');
      this.overlay = $('#SignupPopupOverlay');
      if(!this.popup) return;

      $$('[data-signup-popup-close]', this.popup).forEach(b => b.addEventListener('click', () => this.dismiss()));
      if(this.overlay) this.overlay.addEventListener('click', () => this.dismiss());
      document.addEventListener('keydown', (e)=>{ if(e.key==='Escape' && this.isOpen()) this.dismiss(); });

      $$('[data-signup-show]', this.popup).forEach(btn => {
        btn.addEventListener('click', () => this.showPanel(btn.dataset.signupShow));
      });

      // Side tab: clicking it always reopens the popup immediately,
      // regardless of the dismiss cooldown — it's a deliberate re-request.
      const tabWrap = $('#SignupSideTabWrap');
      const sideTab = $('#SignupSideTab');
      const sideTabClose = $('#SignupSideTabClose');

      if(tabWrap && localStorage.getItem(this.TAB_HIDDEN_KEY) === '1'){
        tabWrap.classList.add('is-hidden');
      }

      if(sideTab){
        sideTab.addEventListener('click', () => this.open());
      }
      if(sideTabClose && tabWrap){
        sideTabClose.addEventListener('click', (e) => {
          e.stopPropagation();
          tabWrap.classList.add('is-hidden');
          localStorage.setItem(this.TAB_HIDDEN_KEY, '1');
        });
      }

      // Testing bypass: add ?show_popup=1 to any homepage URL to force it open
      // immediately, ignoring the 7-day dismiss cooldown entirely.
      const params = new URLSearchParams(window.location.search);
      if(params.get('show_popup') === '1'){
        this.open();
        return;
      }

      const justSubmitted = this.popup.querySelector('.signup-popup__success, .signup-popup__error');
      if(justSubmitted){
        this.open();
        return;
      }

      const dismissedUntil = parseInt(localStorage.getItem(this.STORAGE_KEY) || '0', 10);
      if(Date.now() < dismissedUntil) return;

      setTimeout(() => this.open(), 4000);
    },

    isOpen(){ return this.popup.classList.contains('is-open'); },

    open(){
      this.popup.classList.add('is-open');
      this.popup.setAttribute('aria-hidden', 'false');
      if(this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    dismiss(){
      this.popup.classList.remove('is-open');
      this.popup.setAttribute('aria-hidden', 'true');
      if(this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      const sevenDays = 7 * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.STORAGE_KEY, String(Date.now() + sevenDays));
    },

    showPanel(name){
      $$('[data-signup-panel]', this.popup).forEach(p => {
        p.hidden = p.dataset.signupPanel !== name;
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    HeaderSearch.init();
    MobileMenu.init();
    ProductGallery.init();
    SignupPopup.init();
  });
})();
